/* FONTS
* ----------------------------------
*/
// RegExp to require all (.fonts-) assets in '../fonts'-directory.
var fontsContext = require.context("../fonts", true, /\.woff(2)?|ttf|eot$/);
fontsContext.keys().forEach(function (key) {
	fontsContext(key);
});

/* IMG
* ----------------------------------
*/
// RegExp to require all (.img-) assets in '../img'-directory.
var imgContext = require.context("../img", true, /\.(png|gif|jpg|svg)$/);
imgContext.keys().forEach(function (key) {
	imgContext(key);
});

/* SCSS
* ----------------------------------
*/
require('../scss/app.scss'); // All other scss assets are imported in this file

/* JS
* ----------------------------------
*/
// RegExp to require all (.js-) assets in './custom'-directory.
var jsContext = require.context("./custom", true, /\.js$/);
jsContext.keys().forEach(function (key) {
	jsContext(key);
});
